import setCss from './set-css'
import browser from './browser'

import { offEvent, onEventPassive } from './on-event'

const EMPTY_SRC = ''

const LOAD_EVENT = 'load'
const ERROR_EVENT = 'error'

const SVG_URL_RE = /\.svg$/i
const SVG_DATA_RE = /^data:image\/svg\+xml;base64,/i
const REQUIRE_SVG_CHECK = browser.likeIE

const APPLY_HIDE_CSS = {
  position: 'absolute',
  left: '-10000px'
}
const RESET_HIDE_CSS = {
  position: null,
  left: null
}

export default function MyImageLoaded(
  src,
  target,
  ownerCallback,
  ownerContext) {

  this.ownerCallback = ownerCallback
  this.ownerContext = ownerContext

  this.src = src
  this.target = target
  this.proxyImg = undefined

  this.completed = false
  this.cleaned = false
}

MyImageLoaded.prototype.init = function() {
  this.proxyImg = this.target ? this.target : new window.Image()
  this.proxyImg.src = this.src

  onEventPassive(this.proxyImg, LOAD_EVENT, this)
  onEventPassive(this.proxyImg, ERROR_EVENT, this)
}

MyImageLoaded.prototype.handleEvent = function(event) {
  if (event.type === LOAD_EVENT) {
    this.onload()
  } else if (event.type === ERROR_EVENT) {
    this.onerror()
  }
}

MyImageLoaded.prototype.onload = function() {
  if (this.completed) return
  this.completed = true

  if (this.proxyImg && this.ownerCallback && this.ownerContext) {
    const size = getImgSize(this.proxyImg)
    this.ownerCallback.call(this.ownerContext, null, size)
  }
}

MyImageLoaded.prototype.onerror = function() {
  if (this.completed) return
  this.completed = true

  if (this.ownerCallback && this.ownerContext) {
    const err = new Error(`MyImageLoaded: can't load ${this.src}!`)
    this.ownerCallback.call(this.ownerContext, err)
  }
}

MyImageLoaded.prototype.cleanup = function() {
  if (this.cleaned) return
  this.cleaned = true

  this.src = undefined
  this.ownerContext = undefined
  this.ownerCallback = undefined

  if (this.proxyImg) {
    offEvent(this.proxyImg, LOAD_EVENT, this)
    offEvent(this.proxyImg, ERROR_EVENT, this)
    this.proxyImg = undefined
  }
}

MyImageLoaded.prototype.kill = function() {
  if (this.killed) return
  this.killed = true

  if (this.proxyImg) {
    this.proxyImg.src = EMPTY_SRC
  }

  this.cleanup()
}

// -------------------------- helpers -------------------------- //

function getImgSize(elm) {
  return REQUIRE_SVG_CHECK && isSvgImg(elm)
    ? getOffsetImgSize(elm)
    : getNaturalImgSize(elm)
}

function isSvgImg(elm) {
  return SVG_URL_RE.test(elm.src) || SVG_DATA_RE.test(elm.src)
}

function getOffsetImgSize(elm) {
  let childIndex = 0
  const parentNode = elm.parentNode

  if (parentNode && (parentNode.children.length !== 1)) {
    for (let index = 0, length = parentNode.children.length; index !== length; index++) {
      const child = parentNode.children[index]
      if (child === elm) {
        childIndex = index
        break
      }
    }
  }

  document.body.appendChild(elm)
  setCss(elm, APPLY_HIDE_CSS)
  const size = {
    width: elm.offsetWidth,
    height: elm.offsetHeight
  }
  setCss(elm, RESET_HIDE_CSS)

  if (parentNode) {
    if (parentNode.children.length === 0) {
      parentNode.appendChild(elm)
    } else {
      const next = parentNode.children[childIndex]
      parentNode.insertBefore(elm, next)
    }
  } else {
    document.body.removeChild(elm)
  }

  return size
}

function getNaturalImgSize(elm) {
  return {
    width: elm.naturalWidth,
    height: elm.naturalHeight
  }
}
